import { shouldAutoSubmitEventDateFilter, submitEventFilterForm } from './event-filters-logic';

/**
 * Native date inputs: label + field opens picker where showPicker() exists (Chrome, Safari 16+).
 */
export default function initEventFilters() {
    const root = document.querySelector('.event-filters');
    if (!root) {
        return;
    }

    const form = root.querySelector('.event-filters__form--primary');
    const franInput = root.querySelector('#event-fran');
    const tillInput = root.querySelector('#event-till');
    const pageHadDateFilter = root.dataset.activeDateFilter === '1';

    const maybeSubmitDateFilter = () => {
        if (!form || !franInput || !tillInput) {
            return;
        }
        if (shouldAutoSubmitEventDateFilter(franInput.value, tillInput.value, pageHadDateFilter)) {
            submitEventFilterForm(form);
        }
    };

    root.querySelectorAll('.event-filters__date input[type="date"]').forEach((input) => {
        input.addEventListener('change', maybeSubmitDateFilter);
        const field = input.closest('.event-filters__date');
        if (!field) {
            return;
        }

        const openPicker = () => {
            input.focus();
            if (typeof input.showPicker === 'function') {
                try {
                    input.showPicker();
                } catch (err) {
                    // showPicker throws if not triggered by user gesture in some browsers.
                }
            }
        };

        field.querySelectorAll('.event-filters__field-label').forEach((label) => {
            label.addEventListener('click', (event) => {
                event.preventDefault();
                openPicker();
            });
        });

        input.addEventListener('click', () => {
            if (typeof input.showPicker === 'function') {
                try {
                    input.showPicker();
                } catch (err) {
                    // Ignore — native control still works.
                }
            }
        });
    });
}

export { shouldAutoSubmitEventDateFilter, submitEventFilterForm };
